import { useMemo } from 'react'

import { useMemberships } from '@/features/membership'

export function useUser(id: number | null) {
  const members = useMemberships()

  return useMemo(
    () => members.find(member => member.userId === id)?.user,
    [members, id]
  )
}
